import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  type: "file"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  value: "hello"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Submit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.debug)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDebug && _ctx.onDebug(...args)), ["prevent"])),
          style: {"position":"fixed","z-index":"10000"}
        }, [
          (_ctx.debug === 'create')
            ? (_openBlock(), _createElementBlock("input", _hoisted_1))
            : _createCommentVNode("", true),
          _hoisted_2,
          _hoisted_3
        ], 32))
      : _createCommentVNode("", true)
  ]))
}